export function getMimeTypeFromDataURL(dataURL: string) {
	return (dataURL.substring(dataURL.indexOf(':') + 1, dataURL.indexOf(';')));
};

export interface IURL {
	route: string;
	parameters: Record<string, string | number | true>;
};

export function URL_parse(URLLike: string | URL | Location | IURL): IURL {
	let route: string;
	let rawParametersList: string;
	if (typeof URLLike === 'string') {
		const hasParameters = URLLike.includes('?');
		if (hasParameters) {
			route = URLLike.slice(0, URLLike.indexOf('?'));
			rawParametersList = URLLike.slice(URLLike.indexOf('?'));
		} else {
			route = URLLike;
			rawParametersList = '';
		}
	} else {
		if ((URLLike instanceof Location) || (URLLike instanceof URL)) {
			route = `${URLLike.origin}${URLLike.pathname}`;
			rawParametersList = URLLike.search;
		} else {
			return URLLike;
		}
	}
	const parameters = !rawParametersList.length ?
		{} :
		(rawParametersList.startsWith('?') ? rawParametersList.slice(1) : rawParametersList).split('&').
		map(x => x.split('=')).
		reduce((a, c) => {
			const key = decodeURIComponent(<string>c[0]).trim();
			a[key] = c.length === 2 ? decodeURIComponent(<string>c[1]).trim() : true;
			return a;
		}, <Record<string, string | true>>{})
	;
	return {
		parameters,
		route,
	};
};

export function URL_format(
	URLLike: string | URL | Location | IURL,
	parameters: { [key: string]: string | number | boolean } = {}
) {
	const parsed = URL_parse(URLLike);
	const finalParameters = Object.entries({...parsed.parameters, ...parameters});
	return !finalParameters.length ?
		sanitizeRoute(parsed.route) :
		`${sanitizeRoute(parsed.route)}?${finalParameters.map(([key, value]) => `${key}=${value}`).join('&')}`;
};

export function URL_changeAndFormat(
	URLLike: string | URL | Location | IURL,
	updater: (URL: IURL) => void
) {
	const URL = URL_parse(URLLike);
	updater(URL);
	return URL_format(URL);
};

export function URL_normalize<TIN extends string | URL | Location | IURL>(
	_in: TIN
): TIN extends string ? string : TIN extends URL ? URL : TIN extends Location ? Location : IURL {
	if (_in instanceof URL || _in instanceof Location) {
		return <any>_in;
	}
	const isString = typeof _in === 'string';
	let route = sanitizeRoute(isString ? _in : _in.route);
	try {
		const _URL = new URL(route);
		route = _URL.href;
	} catch (error: any) {
		const _URL = new URL(route, location.href);
		route = _URL.href;
	}
	if (!isString) {
		_in.route = route;
		return <any>_in;
	}
	return <any>route;
};

const sanitizeRoute = (route: string) => {
	return route.replace(/(?<!:)\/{2,}/g, '/');
};

